import React from "react";
import './ConfirmDialog.css';

type ConfirmDialogProps = {
    title: string;
    show: boolean;
    ok: string
    cancel: string;

    okIsGray?: boolean;

    onOk?: () => void;
    onCancel?: () => void;
    children?: React.ReactNode;
}

export const ConfirmDialog = (props: ConfirmDialogProps) => {

    const ref = React.useRef<HTMLDialogElement | null>(null);

    React.useLayoutEffect(() => {
        if (ref.current === null) {
            return;
        }

        if (props.show) {
            ref.current.showModal();
        } else {
            ref.current.close();
        }
    }, [props.show]);

    return (
        <dialog className="confirm-dialog" ref={ref} onCancel={() => props.onCancel?.()}>
            <div onClick={e => e.stopPropagation()}>
                <p className="confirm-dialog-title-area">{props.title}</p>
                <span className="confirm-dialog-close-button" onClick={() => props.onCancel?.()}/>
                <p className="confirm-dialog-message-area">{props.children}</p>
                <p className="confirm-dialog-button-area">
                    <button className="confirm-button-cancel" onClick={() => props.onCancel?.()}>{props.cancel}</button>
                    <button className={props.okIsGray === true ? "confirm-button-ok-gray" : "confirm-button-ok"} onClick={() => props.onOk?.()}>{props.ok}</button>
                </p>
            </div>
        </dialog>
    );

}
